import { render, staticRenderFns } from "./cms-block-glyph.vue?vue&type=template&id=d9811be4&scoped=true"
import script from "./cms-block-glyph.vue?vue&type=script&lang=js"
export * from "./cms-block-glyph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9811be4",
  null
  
)

export default component.exports